import React, { useState, Fragment, useEffect } from 'react';
import { useForm, FormContext } from 'react-hook-form';
import { useStyle } from './style';
import { Paper, Grid, Box, Button, Stepper, Step, StepLabel } from '@material-ui/core';
import { makeStyles, withStyles, createMuiTheme, ThemeProvider } from '@material-ui/core/styles';
import { theme } from './theme';
import axios from 'axios';
import StepConnector from '@material-ui/core/StepConnector';
import EirInstallationInfo from './EirInstallationInfo';
import EirInstallationEquipment from './EirInstallationEquipment';
import EirInstallationAddress from './EirInstallationAddress';
import EirAddressFinderContainer from './EirAddressFinderContainer';
import { isMobileOnly } from 'react-device-detect';
import clsx from 'clsx';
import { Icon } from '@material-ui/core';

export default function EirInstallationDetailsContainer(props) {
	const { handleSubmit, errors } = useForm();
	const classes = useStyle();
	const [existingProvider, setExistingProvider] = useState(null);
	const [techInstallationValue, setTechInstallationValue] = useState(null);
	const [checkBoxMonitor, setCheckBoxMonitor] = useState(true);
	const [errorAgree, setErrorAgree] = useState(false);

	const onSubmitData = data => {
		let isError = false;
		if (Object.keys(methods.errors).length > 0) {
			isError = true;
			Object.keys(methods.errors).forEach((item) => {
				methods.setError(item, methods.errors[item].type, methods.errors[item].message);
			});
		}
		if (!isError) {
			if (data.monitoredAlarm === 'yes' && !errorAgree)
				setCheckBoxMonitor(false);//checking to option check
			else
				saveInstallationDetails(data);
		}
	};
	const saveInstallationDetails = data => {
		var bodyFormData = new FormData();
		if (data.landline)
			bodyFormData.append('hasHomeLandline', data.landline);
		if (data.movingBroadband)
			bodyFormData.append('isSwitchingProvider', data.movingBroadband);
		if (data.broadbandProvider)
			bodyFormData.append('existingProvider', data.broadbandProvider);
		if (data.broadbandProvider === 'OTHER') {
			bodyFormData.append('existingProviderOther', data.otherProvider);
		}
		if (data.prefix && data.landlineNumber) {
			bodyFormData.append('existingLandlinePrefix', data.prefix);
			bodyFormData.append('existingLandlineNumber', data.landlineNumber);
		}
		if (data.accountNumber)
			bodyFormData.append('existingProviderAccountNumber', data.accountNumber);
		if (data.monitoredAlarm)
			bodyFormData.append('monitoredAlarm', data.monitoredAlarm);
		if (broadBandTypeFTH) {
			bodyFormData.append('masterSocket', 'no');
			bodyFormData.append('installationTypePreference', 'TECH_INSTALL');
		} else {
			bodyFormData.append('masterSocket', data.masterSocket);
			bodyFormData.append('installationTypePreference', techInstallationValue);
			if (techInstallationValue === 'TECH_INSTALL_OPTIONAL')
				bodyFormData.append('requiresTechInstall', (data.techInstall === 'yes' ? true : false));
		}


		/*Installation Address part start*/
		// 	if (localStorage.getItem('eir_be_data')) {
		// 	let order = JSON.parse(localStorage.getItem('eir_be_data')).order;
		// 	if(order.prequal.fullAddress){
		// 		let fullAddress = (order.prequal.fullAddress);
		// 		const addressArray = fullAddress.split(',');
		// 		let arrLength = addressArray.length;
		// 		bodyFormData.append('installationAddress.county', addressArray[arrLength - 1]);
		// 		bodyFormData.append('installationAddress.town', addressArray[arrLength - 2]);
		// 		let add1 = '';
		// 		for (let i = 0; i < (arrLength - 2); i++) {
		// 			add1 = add1.concat(addressArray[i]);
		// 			add1 = add1.concat(',');
		// 		}
		// 		bodyFormData.append('installationAddress.address1', add1);
		// 	}	
		// 	else{
		// 		bodyFormData.append('installationAddress.address1', data.billingAddressaddressLine1);
		// 		bodyFormData.append('installationAddress.address2', data.billingAddressaddressLine2);
		// 		bodyFormData.append('installationAddress.county', data.billingAddresscounty);
		// 		bodyFormData.append('installationAddress.town',data.billingAddresstown);
		// 		bodyFormData.append('eircode',data.billingAddressEirCode);
		// 	}		
		// }
		let insAdd = JSON.parse(sessionStorage.getItem('insAdd'))[0];
		//console.log('insAdd insDetails>>>>>>>',insAdd);
		bodyFormData.append('installationAddress.address1', insAdd.address1);
		bodyFormData.append('installationAddress.address2', insAdd.address2);
		bodyFormData.append('installationAddress.address3', insAdd.address3);
		bodyFormData.append('installationAddress.county', insAdd.county);
		bodyFormData.append('installationAddress.town', insAdd.town);
		bodyFormData.append('installationAddress.eircode', insAdd.eircode);
		/*Installation Address part end*/
		if (data.prefDate) {
			bodyFormData.append('installationDate', data.prefDate.toDate().getDate() + '/' +
				(data.prefDate.toDate().getMonth() + 1) + '/' + data.prefDate.toDate().getFullYear());
		}
		if (data.prefInstallationTime)
			bodyFormData.append('installationTimeOfDay', data.prefInstallationTime);
		bodyFormData.append('securityQuestion', 'Name a memorable date');//default value
		bodyFormData.append('securityAnswer', sessionStorage.getItem('custDob'));//default value
		bodyFormData.append('billDeliveryMethod', 'ONLINE_ONLY');//default value
		bodyFormData.append('isLandlineDirectoryListing', false);//default value
		bodyFormData.append('disallowThirdPartyMarketing', true);//default value
		if (localStorage.getItem('eir_be_data')) {
			bodyFormData.append('orderId', JSON.parse(localStorage.getItem('eir_be_data')).order.id);
		}
		submitInstallationDetails(bodyFormData);
	}
	async function submitInstallationDetails(bodyFormData) {
		try {
			let urlPath = '/store/api/checkout/service-details/';
			let res = await axios({
				method: 'POST',
				url: urlPath,
				data: bodyFormData,
				headers: { 'Content-Type': 'multipart/form-data' },
			})
			if (res.status == 200) {
				if (res.data.success) {
					if (activeStep !== props.steps.length - 1) {
						setCustomerCheckoutActiveStep((prevActiveStep) => prevActiveStep + 1);
						setStepperClickablefromID(true);
					} else {
						console.log(res.data.validationErrors[0].message);
					}
				} else {
					console.log(res);
				}
			} else {
				//system error without retry
				console.log(res.status);
			}
		}
		catch (err) {
			console.error(err);
		}
	}
	const customerCheckoutActiveStep = props.customerCheckoutActiveStep;
	useEffect(() => {
		setActiveStep(1);
		window.scrollTo(0, 0);
		onloadData();
	}, [customerCheckoutActiveStep]);
	const setCustomerCheckoutActiveStep = function (index) {
		props.setCustomerCheckoutActiveStep(index);
	}
	const methods = useForm(
		{
			mode: 'onChange',
			defaultValues: {},

		}
	);

	const defaultTheme = createMuiTheme();
	const ColorlibConnector = withStyles({
		alternativeLabel: {
			top: (isMobileOnly) ? 22 : 16,
		},
		alternativeLabel: {
			top: 22,
			[defaultTheme.breakpoints.down(768)]: {
				top: 16,
				left: -50,
			}
		},
		active: {
			'& $line': {
				backgroundImage:
					'linear-gradient( 95deg,rgba(148,62,169,255) 0%,rgba(174,53,184,255) 50%,rgba(210,39,204,255) 100%)',
			},
		},
		completed: {
			'& $line': {
				backgroundImage:
					'linear-gradient( 95deg,rgba(148,62,169,255) 0%,rgba(174,53,184,255) 50%,rgba(210,39,204,255) 100%)',
			},
		},
		line: {
			height: '0.15rem',
			border: 0,
			backgroundColor: '#eaeaf0',
			borderRadius: 1,
			width: 96,
			margin: '0 auto',
		},
	})(StepConnector);

	const useColorlibStepIconStyles = makeStyles({
		root: {
			backgroundColor: '#ccc',
			zIndex: 1,
			color: '#fff',
			width: 40,
			height: 40,
			display: 'flex',
			borderRadius: '50%',
			justifyContent: 'center',
			alignItems: 'center',
		},
		active: {
			boxShadow: '0 4px 10px 0 rgba(0,0,0,.25)',
			backgroundSize: 100,
			background: 'linear-gradient(180deg, #892BA0 0%, #470A68 100%);',
		},
		completed: {
			background: 'linear-gradient(180deg, #892BA0 0%, #470A68 100%);',
		},
		'& .stepperIcon': {
			marginTop: '-1.4rem',
			marginLeft: '.4rem',
			height: 13,
			width: 7,
		},
	});

	function ColorlibStepIcon(props) {
		const classes = useColorlibStepIconStyles();
		const { active, completed } = props;

		const icons = {
			1: <Icon><img className="stepperIcon1" src={'/.galleries/checkout/1.png'} height={25} width={25} /></Icon>,
			2: <Icon><img className="stepperIcon2" src={'/.galleries/checkout/2.png'} height={25} width={25} /></Icon>,
			3: <Icon><img className="stepperIcon3" src={'/.galleries/checkout/3.png'} height={25} width={25} /></Icon>,
		};

		return (
			<div
				className={clsx(classes.root, {
					[classes.active]: active,
					[classes.completed]: completed,
				})}
			>
				{icons[String(props.icon)]}
			</div>
		);
	}

	const [activeStep, setActiveStep] = React.useState(1);
	const steps = getSteps();
	const stepperClickablefromID = props.stepperClickablefromID;
	const setStepperClickablefromID = props.setStepperClickablefromID;
	const handleBack = () => {
		if (activeStep !== 0) {
			setActiveStep((prevActiveStep) => prevActiveStep - 1);
			setCustomerCheckoutActiveStep((prevActiveStep) => prevActiveStep - 1);
		}
	};
	function getSteps() {
		if (JSON.parse(localStorage.getItem("eir_be_data"))) {
			if (JSON.parse(localStorage.getItem("eir_be_data")).order.prequal.customerType == "NEW") {
				if (isMobileOnly) {
					return ['Customer', 'Installation', 'Payment'];
				}
				else {
					return ['Customer Details', 'Installation Details', 'Payment Details'];
				}
			}
			else if (JSON.parse(localStorage.getItem("eir_be_data")).order.prequal.customerType == JSON.parse(localStorage.getItem("eir_be_data")).order.bundle.broadband.plan.type) {
				if (isMobileOnly) {
					return ['Customer', 'Payment'];
				}
				else {
					return ['Customer Details', 'Payment Details'];
				}
			}
			else {
				if (isMobileOnly) {
					return ['Customer', 'Installation', 'Payment'];
				}
				else {
					return ['Customer Details', 'Installation Details', 'Payment Details'];
				}
			}
		}
	}
	const handleStep = (step) => () => {
		// stepper should be clickable only when all details are filled
		if (step < 1) {
			setActiveStep(step);
			setCustomerCheckoutActiveStep(step);
		}
		else {
			if (stepperClickablefromID) {
				setActiveStep(step);
				setCustomerCheckoutActiveStep(step);
			}
		}
	};
	const [prequalAddress, setPrequalAddress] = useState(null);
	const [hasInstallationFee, setHasInstallationFee] = useState(false);
	const [hasFTTH, setHasFTTH] = useState(false);
	const [showTechInstallationMsg, setShowTechInstallationMsg] = useState(null);
	const [broadBandTypeFTH, setBroadBandTypeFTH] = useState(false);
	const [showEirInstallationInfo, setShowEirInstallationInfo] = useState(true);
	const onloadData = () => {
		if (localStorage.getItem('eir_be_data')) {
			let order = JSON.parse(localStorage.getItem('eir_be_data')).order;
			if (order.prequal.fullAddress) {
				//setPrequalAddress((order.prequal.fullAddress).replace(/, /g, ',\n'));
				//setHasInstallationFee(order.hasInstallationFee);
				setHasFTTH(order.prequal.ifth);
			} else {
				setHasInstallationFee(order.hasInstallationFee);
			}
			if (order.bundle && order.bundle.broadband && order.bundle.broadband.plan) {//broadbandType FTH checking
				if (order.bundle.broadband.plan.type === 'FTH' || order.bundle.broadband.plan.type === 'NBI'){
					setBroadBandTypeFTH(true);
					setTechInstallationValue('TECH_INSTALL');
					setHasInstallationFee(true);
					if ((order.bundle.broadband && order.bundle.tv != null) || (order.bundle.broadband && order.bundle.tv != null && order.bundle.mobiles.length > 0)) {
						setShowTechInstallationMsg("We'll send you an email and text message to confirm your activation/installation date and time. Note that your eir TV (Apple TV) box can be self-installed, it will be sent to you by courier after your broadband service is active.");
					} else {
						setShowTechInstallationMsg("We'll send you an email and text message to confirm your activation/installation date and time.");
					}
				}				
			}
			let prequalCusType = null;
			let planType = null;
			if (order.prequal && order.prequal.customerType) {
				prequalCusType = order.prequal.customerType;
			}
			if (order.bundle.broadband && order.bundle.broadband.plan.type) {
				planType = order.bundle.broadband.plan.type
			}
			if ((prequalCusType && planType) && ((prequalCusType === 'NGB' && planType === 'FTH') || (prequalCusType === 'NGB' && planType === 'FTC') || (prequalCusType === 'FTC' && planType === 'FTH'))) {
				setShowEirInstallationInfo(false);
			} else {
				setShowEirInstallationInfo(true);
			}
		}
	}
	return (
		<Fragment>
			<ThemeProvider theme={theme}>
				<FormContext {...methods}>
					{/* Start Stepper Zone */}
					<Grid>
						<Paper elevation={3} className={classes.paper}>
							<div className={classes.root + " container"}>
								<div onClick={handleBack} className={" float-left checkoutStep_back "}>
									Back
								</div>
								<Grid item xs={12} id="customer_checkout_container">
									<Box display={{ xs: 'none', md: 'block' }} >
										<Stepper activeStep={activeStep} connector={<ColorlibConnector />}>
											{(steps) && steps.map((label, index) => (
												<Step key={label}>
													<StepLabel onClick={handleStep(index)} StepIconComponent={ColorlibStepIcon} >{label}</StepLabel>
												</Step>
											))}
										</Stepper>
									</Box>
									<Box display={{ xs: 'block', md: 'none' }}>
										<Stepper alternativeLabel activeStep={activeStep} connector={<ColorlibConnector />}>
											{(steps) && steps.map((label, index) => (
												<Step key={label} id={"step-" + index}>
													<StepLabel onClick={handleStep(index)} StepIconComponent={ColorlibStepIcon} >{label}</StepLabel>
												</Step>
											))}
										</Stepper>
									</Box>
								</Grid >
								<div class={" float-right checkoutStep_next "} onClick={methods.handleSubmit(onSubmitData)}>
									Next
								</div>
							</div >
						</Paper>
					</Grid>
					{/* END Stepper Zone */}
					<Grid>
						<Grid container className={classes.mainContainer}>
							<Grid container sm={12}>
								<Grid container sm={12} className={classes.pageInstallationTitlePadding}>
									<Grid item sm={7}>
										<h1 className={classes.pageInstallationHeading}>Installation Details</h1>
									</Grid>
								</Grid>
							</Grid>
							<Grid item sm={12}>
								<form>
									{showEirInstallationInfo ?
										<EirInstallationInfo setExistingProvider={setExistingProvider}
											setCheckBoxMonitor={setCheckBoxMonitor}
											checkBoxMonitor={checkBoxMonitor}
											setErrorAgree={setErrorAgree}
											errorAgree={errorAgree}></EirInstallationInfo>
										: ''}
									{!broadBandTypeFTH ?
										<EirInstallationEquipment
											hasFTTH={hasFTTH}
											existingProvider={existingProvider}
											setHasInstallationFee={setHasInstallationFee}
											setShowTechInstallationMsg={setShowTechInstallationMsg}
											setTechInstallationValue={setTechInstallationValue} />
										: ''}
									{/* {prequalAddress?'':<EirAddressFinderContainer/>}									 */}
									{techInstallationValue && techInstallationValue !== 'SELF_INSTALL' ?
										<EirInstallationAddress
											prequalAddres={prequalAddress}
											hasInstallationFee={hasInstallationFee}
											showTechInstallationMsg={showTechInstallationMsg}
										></EirInstallationAddress>
										: ''}
									<div className="bottom_Installation_Buttons">
										<div
											onClick={handleBack}
											className={'float-left bottom_stepBack'}>
											Back</div>
										<Button className={classes.btnNextStepper} onClick={methods.handleSubmit(onSubmitData)} >Step {props.customerCheckoutActiveStep + 2}: {props.BottomNextText}</Button>
									</div>
								</form>
							</Grid>
						</Grid>
					</Grid>
				</FormContext>
			</ThemeProvider>
		</Fragment>
	);
}